import styled from 'styled-components';

export const NoDataBlockWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    justify-content: flex-start;
    height: 100%;
    padding: 10px 0;
    color: #999aa0;
`;
